import { TextField, useMediaQuery, useTheme } from '@mui/material'
import { DesktopDatePicker, MobileDatePicker } from '@mui/x-date-pickers'
import React, { useState } from 'react'
import { useSmartTranslation } from '../hooks/useSmartTranslation'
import { useDateFormatter } from '../hooks/useDateFormatter'

const Index = (props) => {
  const { resultDate } = props
  const [entryDate, setEntryDate] = useState(resultDate.current)

  const theme = useTheme()
  const isMobileIsTablet = useMediaQuery(theme.breakpoints.down('sm'))
  const { t_ } = useSmartTranslation()
  const { format } = useDateFormatter()

  return (

    isMobileIsTablet
      ? (

        <MobileDatePicker
          disableMaskedInput
          label={t_('Entry date')}
          format={format.dateTime}
          value={entryDate}
          onChange={(newValue) => {
            setEntryDate(newValue)
            resultDate.current = newValue
          }}
          renderInput={(params) => <TextField {...params} />}
        />
        )
      : <DesktopDatePicker
          disableMaskedInput
          label={t_('Entry date')}
          format={format.dateTime}
          value={entryDate}
          onChange={(newValue) => {
            setEntryDate(newValue)
            resultDate.current = newValue
          }}
          renderInput={(params) => <TextField {...params} />}
        />

  )
}

export default Index
